import { AdFoxBanner, IAdFoxBannerContext } from '@cian/adfox';
import * as React from 'react';

import { IMAGE_APPEARANCE, IMAGE_POSITION, IPromoBlock } from '../../models/promo_block';
import { adfoxMortgageConstants, IAdfoxConstants } from '../adfox/constants';
import { FinanceMainPage } from '../finance_mainpage';
import { PromoImage } from './promo_image';
import { PromoLinks } from './promo_links';
import { adFoxMortgageMiddleware, PromoMortgage } from './promo_mortgage';
const s = require('./promo_block.css');

interface IProps {
  isMortgage: boolean;
  promoBlock: IPromoBlock;
  class?: string;
  onLinkClick(url: string): void;
}

const IMAGE_POSITIONS = {
  [IMAGE_POSITION.left]: 'left',
  [IMAGE_POSITION.right]: 'right',
  [IMAGE_POSITION.none]: 'none',
};

const IMAGE_APPEARANCES = {
  [IMAGE_APPEARANCE.show]: 'show',
  [IMAGE_APPEARANCE.hide]: 'hide',
  [IMAGE_APPEARANCE.stay]: 'stay',
};

export const PromoBlock = (props: IProps) => {
  const { isMortgage, promoBlock } = props;
  const imgPos = IMAGE_POSITIONS[promoBlock.imagePosition];
  const imgAppear = IMAGE_APPEARANCES[promoBlock.imageAppearance];
  // компонент AdFoxBanner может вернуть null,
  // что пораждает ошибку типизации. Попытка поднять версии реакта и тайпскрипта
  // до версии в либе @cian/adfox не увенчалась успехом, и ошибка продолжала
  // воспроизводиться. Таким образом, вот такой хак.
  // tslint:disable-next-line:no-any
  const AnyComponent = AdFoxBanner as any;

  return (
    <div className={`${s['c-promo-block']} ${s['c-promo-block-image-' + imgPos]} ` +
      `${s['c-promo-block-image-' + imgAppear]} ${props.class || ''}`}>
      {
        isMortgage &&
          <div className={s['c-promo-block-image']}>
            <AnyComponent
              middleware={() => adFoxMortgageMiddleware(adfoxMortgageConstants as IAdfoxConstants)}
              renderLoading={() =>
                <PromoImage
                  imageUrl={promoBlock.imageUrl}
                  extraLinks={promoBlock.promo.extraLinks}
                />}
              renderFetched={(context: IAdFoxBannerContext) =>
                context.type === 'promo'
                ? <PromoMortgage
                    url={context.url}
                    imageUrl={context.imageUrl}
                    title={context.title}
                    description={context.description}
                    backgroundColor={context.backgroundColor}
                    textColor={context.textColor}
                  />
                : <FinanceMainPage
                    imageUrl={context.imageUrl}
                    reference={context.url}
                  />
              }
              renderFailure={() =>
                <PromoImage
                  imageUrl={promoBlock.imageUrl}
                  extraLinks={promoBlock.promo.extraLinks}
                />
              }
            />
          </div>
      }
      {
        (promoBlock.imagePosition !== IMAGE_POSITION.none && !isMortgage) &&
          <div className={s['c-promo-block-image']}>
            <PromoImage
              imageUrl={promoBlock.imageUrl}
              extraLinks={promoBlock.promo.extraLinks}
            />
          </div>
      }
      <div className={s['c-promo-block-text']}>
        <PromoLinks
          promo={promoBlock.promo}
          onLinkClick={(url) => props.onLinkClick(url)}
        />
      </div>
    </div>
  );
};
